import { useMutation } from 'react-query';
import { useSelector } from 'react-redux';
import { currentClientIdSelector } from '../../CommonSelectors/CommonAreaSelector';
import { authFetch } from '../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { Answers } from '../Survey/Survey.meta';

interface Params {
  clientId: number;
  answers: Answers;
}

interface PostAnswersResponse {
  compareToSurveyId: string | null;
}

const postAnswers = async ({ answers, clientId }: Params): Promise<PostAnswersResponse> => {
  const [data] = await Promise.all([
    authFetch(urlWithParams(`/BeFi20/Survey/Answers`, { clientId }), {
      method: 'POST',
      ...httpBodyOptions(Object.values(answers), true),
    }),
    new Promise(r => setTimeout(r, 1000)),
  ]);

  return data;
};

type MutationParams = Omit<Params, 'clientId'>;

export const usePostAnswersMutation = () => {
  const clientId = useSelector(currentClientIdSelector);

  return useMutation(({ answers }: MutationParams) => postAnswers({ clientId, answers }));
};
